<template>
  <div>
    <div class="teams" id="teams_id" style="display: flex;flex-direction: column;margin-top: 10px !important;">
      <div style="width: 100%;display: flex;justify-content:space-between;">
        <h2 class="title">{{ $t("common.myteam") }}</h2>
        <el-button type="primary" link @click="createTeamLink" v-if="isSuperAdmin||isAdmin">
          {{ $t("common.team.create") }}
        </el-button>
      </div>
      <draggable
          style="width: 100%;margin-top: 8px;"
          v-if="!loading"
          v-model="teamListPage"
          group="people"
          animation="300"
          @start="drag = true"
          @end="drag = false"
          item-key="teamId"
          :key="mainKey"
      >
        <template #item="{ element ,index}" style="margin-top: 12px">
          <CardTeam :bordered="false" :height="'max-content'">
            <template #content>
              <div id="move_cards" class="top_title">
              <span slot="title">
                <span @click.stop="toLink(element)" class="pointer">
                  {{ element.teamName }}
                  <span class="pointer_person">
                    {{
                      $t("common.team.numberTeam1", {
                        num: element.teamCount == undefined ? 0 : element.teamCount,
                      })
                    }}</span>
                </span>
                <a @click="changeTeamNameHandler(element)" v-if="element.flag">
                  <el-icon style="margin-left: 10px; color: #409eff;position: relative;top: 4px;">
                    <Edit/>
                  </el-icon>
                </a>
                <a slot="extra" href="#" v-if="element.flag" style="margin-left: 10px;position: relative;top: 4px;">
                  <el-icon
                      @click="inviteTeamMenber(element)"
                      style="color: #409eff"
                  >
                    <CirclePlus/>
                  </el-icon>
                </a>
              </span>
                <span>
                  <el-button link type="primary" @click="handleClickClose(element)">
                    {{ element.isShow ? $t('home.data.close') : $t('home.data.open') }}
                  </el-button>
                </span>
              </div>
              <div class="boxContent fx" style="margin-top: 15px">
                <!-- Other content slots go here -->
                <!-- 未读邮件 -->
                <div
                    class="Item pointer"
                    @click="handleClick('inbox',element.teamId,index,{ name: 'Inbox', query: { teamID: element.teamId } })"
                >
                  <span class="red bold number">{{ element.unReadCount }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("common.email.noread") }}</span>
                </div>
                <!-- 跟进提醒 -->
                <div
                    class="Item pointer"
                    @click="handleClick('follow_up',element.teamId,index,{ name: 'FollowUp', query: { teamID: element.teamId } })"
                >
                  <span class="red bold number">{{ element.followCount }}</span>
                  <br/>
                  <span class="fs14c000">{{
                      $t("common.followup.emailremind")
                    }}</span>
                </div>
                <!-- 发送失败 -->
                <div
                    class="Item pointer"
                    @click="handleClick('draft',element.teamId,index,{ name: 'Draft', query: { teamID: element.teamId } })"
                >
                  <span class="bold number">{{ element.failCount }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("common.send.failed") }}</span>
                </div>
                <!-- 邮件待审核 -->
                <div
                    class="Item pointer"
                    @click="handleClick('examine',element.teamId,index,{ name: 'Examine', query: { teamID: element.teamId } })"
                >
                  <span class="bold number">{{ element.auditCount }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("common.email.toexamine") }}</span>
                </div>
                <!-- 领用待审核 -->
                <div
                    v-if="element.flag"
                    class="Item pointer"
                    @click="handleClick('examine',element.teamId,index,{
                        name: 'Setting',
                        query: { teamID: element.teamId ,index: 6,tab:4},
                    })"
                >
                  <span class="bold number">{{ element.receiveCount }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("common.claim.toexamine") }}</span>
                </div>
              </div>
              <!--客户-->
              <div class="boxContent fx" style="margin-top:20px;margin-bottom: 15px">
                <!-- Other content slots go here -->
                <!-- 客户跟进 -->
                <div
                    class="Item pointer"
                    @click="handleClick('follow',element.teamId,index,{ name: 'Follow', query: { teamID: element.teamId } })"
                >
                  <span class="red bold number">{{ element.customerFollowCount }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("home.customer.follow") }}</span>
                </div>
                <!-- 收邮件 -->
                <div
                    class="Item pointer"
                    @click="handleClick('inbox',element.teamId,index,{ name: 'Inbox', query: { teamID: element.teamId } })"
                >
                  <span class="bold number">{{ element.yesterdayReceiveEmail }}</span>
                  <br/>
                  <span class="fs14c000">{{
                      $t("home.yesterday.get.email")
                    }}</span>
                </div>
                <!-- 发送邮件 -->
                <div
                    class="Item pointer"
                    @click="handleClick('has_send',element.teamId,index,{ name: 'HasSend', query: { teamID: element.teamId } })"
                >
                  <span class="bold number">{{ element.yesterdaySendEmail }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("home.yesterday.send.email") }}</span>
                </div>
                <!-- 新增客户 -->
                <div
                    class="Item pointer"
                    @click="handleClick('list',element.teamId,index,{ name: 'List', query: { teamID: element.teamId } })"
                >
                  <span class="bold number">{{ element.yesterdayAddCustomer }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("home.yesterday.add.customer") }}</span>
                </div>
                <!-- 客户总数 -->
                <div
                    v-if="element.flag"
                    class="Item pointer"
                    @click="handleClick('list',element.teamId,index,{
                      name: 'List',
                      query: { teamID: element.teamId ,index: 6},
                    })"
                >
                  <span class="bold number">{{ element.customerTotal }}</span>
                  <br/>
                  <span class="fs14c000">{{ $t("home.customer.total") }}</span>
                </div>
              </div>
              <div class="tab_box" v-if="element.isShow">
                <el-tabs v-model="element.activeName" class="demo-tabs" @tab-click="handleClickTab">
                  <el-tab-pane :label="$t('home.dashboard.tab.1')" name="1" lazy>
                    <EmailEcharts :element="element"></EmailEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('home.dashboard.tab.2')" name="2" lazy>
                    <EmailReplayEcharts :element="element"></EmailReplayEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('home.dashboard.tab.3')" name="3" lazy>
                    <CustomerAddEcharts :element="element"></CustomerAddEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('home.dashboard.tab.4')" name="4" lazy>
                    <CustomerOriginEcharts :element="element"></CustomerOriginEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('home.dashboard.tab.5')" name="5" lazy>
                    <CustomerLevelEcharts :element="element"></CustomerLevelEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('home.dashboard.tab.6')" name="6" lazy>
                    <CustomerCountryEcharts :element="element"></CustomerCountryEcharts>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('common.group.edm.email.computed')" name="7" lazy>
                    <GroupEmail :element="element"></GroupEmail>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </template>
          </CardTeam>
        </template>
      </draggable>
    </div>
    <!--创建团队对话框-->
    <Dialog
        v-model="dialogVisible"
        :title="$t('common_team_create')"
        :dialogVisible="dialogVisible "
        :width="'max-content'"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisible = val)"
    >
      <template #content>
        <div class="my_forms">
          <div>{{ $t("common.team.name") }}：</div>
          <div style="margin-top: 8px">
            <el-input size="small" v-model="inputTeamName" @keydown.enter.native="createConfirm"/>
          </div>
        </div>
      </template>
      <template #footer>
        <div id="sendRequire">
          <el-button size="small" :loading="teamLoading" type="primary" @click="createConfirm">{{
              $t("common.confirm")
            }}
          </el-button>
        </div>
      </template>
    </Dialog>
    <!--团队列表-->
    <el-card
        v-loading="loading"
        v-if="loading"
        class="fx-aj-c"
        style="margin-top: 10px; text-align: center; height: 130px;position: relative;z-index: 9"
    >
    </el-card>
    <div class="pages">
      <!--      <el-config-provider :locale="'en'">-->
      <el-pagination
          v-model:current-page="currentTeam"
          v-model:page-size="sizeTeam"
          v-if="totalTeam"
          layout="total, prev, pager, next"
          :total="totalTeam"
          @current-change="handleCurrentChange"
      />
      <!--      </el-config-provider>-->
    </div>
    <PositionWarningPop v-if="dialogVisibleTips" v-model="dialogVisibleTips" @close="close"></PositionWarningPop>
    <!--    修改团队-->
    <Dialog
        v-model="dialogVisibleChangeTeam"
        :title="$t('common.team.modifyName')"
        :width="'max-content'"
        :dialogVisible="dialogVisibleChangeTeam"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleChangeTeam = val)"
    >
      <template #content>
        <div class="my_forms">
          <div>{{ $t('common.team.name') }}：</div>
          <div>
            <el-input size="small" v-model="inputTeamName" @keydown.enter.native="changeTeamName"/>
          </div>
        </div>
      </template>
      <template #footer>
        <div id="sendRequire">
          <el-button size="small" type="primary" @click="changeTeamName">{{ $t('common.confirm') }}</el-button>
        </div>
      </template>
    </Dialog>

    <SearchTargetUserAndSend v-if="dialogVisibleInviteMember" v-model="dialogVisibleInviteMember"
                             @close="closeDia"
                             :teamId="activeTeamsInvite.teamId"></SearchTargetUserAndSend>

  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from "vue";
import draggable from "vuedraggable";
import CardTeam from "@/components/CardTeam.vue";
import {useStore} from "vuex";
import {ElMessage} from "element-plus";
import Dialog from "@/components/Dialog.vue";
import {V2CreateTeam, V2TeamEdit} from "@/api";
import {Search} from "@element-plus/icons-vue";
import {i18n} from "@/lang";
import PositionWarningPop from "@/components/DiaPops/PositionWarningPop.vue";
import CreateTeamPop from "@/components/DiaPops/CreateTeamPop.vue";
import SearchTargetUserAndSend from "@/components/DiaPops/SearchTargetUserAndSend.vue";
import EmailEcharts from "@/views/Home/components/EmailEcharts.vue";
import EmailReplayEcharts from "@/views/Home/components/EmailReplayEcharts.vue";
import CustomerAddEcharts from "@/views/Home/components/CustomerAddEcharts.vue";
import CustomerOriginEcharts from "@/views/Home/components/CustomerOriginEcharts.vue";
import CustomerLevelEcharts from "@/views/Home/components/CustomerLevelEcharts.vue";
import CustomerCountryEcharts from "@/views/Home/components/CustomerCountryEcharts.vue";
import router from "@/router";
import {useRouter} from "vue-router";
import GroupEmail from "@/views/Home/components/GroupEmail.vue";
import sessionStore from "@/utils/sessionStore";

export default defineComponent({
  computed: {
    Search() {
      return Search
    }
  },
  components: {
    GroupEmail,
    CustomerCountryEcharts,
    CustomerLevelEcharts,
    CustomerOriginEcharts,
    CustomerAddEcharts,
    EmailReplayEcharts,
    EmailEcharts, SearchTargetUserAndSend, CreateTeamPop, PositionWarningPop, Dialog, draggable, CardTeam
  },
  setup() {
    const router = useRouter()
    // 判断是否是超级管理员如果是的话 就展示
    // 权限控制
    const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
    const isAdmin = computed(() => store.getters["user/isAdmin"])
    const isEnterpriseChildUser = computed(() => store.getters["user/isEnterpriseChildUser"])

    const store = useStore();
    const teamListPage = computed(() => store.state.home.teamListPage)
    const loadingDone = ref(true);
    const mainKey = ref(0)

    const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)

    // 工位预警
    const dialogVisibleTips = ref(false)
    const dialogVisibleChangeTeam = ref(false)
    const dialogVisibleInviteMember = ref(false);
    const userInfo = computed(() => store.state.user.userInfo);

    // team id
    const teamId = computed(() => store.state.email.teamID);

    const teamList = computed(() => store.state.email.teamList);
    const drag = ref(false)
    const inputSendID = ref('')

    // 获取团队成员--分页
    const currentTeam = computed(() => store.state.home.currentTeam);
    const sizeTeam = computed(() => store.state.home.sizeTeam);
    const totalTeam = computed(() => store.state.home.totalTeam);
    const loading = computed(() => store.state.home.loading)
    const handleCurrentChange = async (page) => {
      store.commit('home/setPages', page)
      await getTeamListPages();
    };

    const getTeamListPages = async () => {
      await store.dispatch("home/getTeamListPages");
      drag.value = false;
      // 数据无法进行交换
      // teamList.value = teamListPage.value;
    }

    const close = () => {
      dialogVisibleTips.value = false
    }

    const closeDia = () => {
      dialogVisibleInviteMember.value = false;
    }

    const handleClick = async (flag, teamId, index, route) => {
      await store.commit('email/setCurTeamID', teamId);
      await sessionStore.set("tabIndex", index)

      // 跳转之前需要判断该团队是否失效
      const targetTeam = teamList.value.find(it => it.id === teamId) || {expireTime: null}
      console.log(targetTeam, 'targetTeam', teamId, teamList.value)
      const time = targetTeam.expireTime;
      if (time === null) {
        // 永久有效
        await store.commit("email/setShouldShowSideBar", true)
        router.push(route)
      } else {
        const timeTemp = new Date(time).getTime();
        const now = Date.now(); // 当前时间戳（毫秒）

        if (timeTemp > now) {
          // 还在有效期内，正常处理
          await store.commit("email/setShouldShowSideBar", true)
          router.push(route)
        } else {
          // 已过期，无效
          await store.commit("email/setShouldShowSideBar", false)
          await router.push(`/email/systemPrompt?teamId=${teamId}&workPositionId=${targetTeam?.workPositionId}`);
        }
      }
    }
    const handleClickTab = (tab, event) => {
      console.log(tab, event, 'test')
    }


    onMounted(async () => {
      await getTeamListPages();
      await store.dispatch("cloud/queryByUserIdApis");
      console.log(teamList.value, 'teamList.value')
      if (teamList.value.length === 0 && !isEnterpriseChildUser.value) {
        createTeamLink()
      }
      // await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value})
    });

    // 创建团队对话框
    const dialogVisible = ref(false);
    //  创建团队
    const inputTeamName = ref("");
    const teamLoading = ref(false)
    const createTeamLink = () => {
      dialogVisible.value = true
    }
    const createConfirm = async () => {
      if (mailWorkPosition.value.freePosition !== 0) {
        if (inputTeamName.value !== '') {
          teamLoading.value = true;
          let res = await V2CreateTeam({
            name: inputTeamName.value,
          });
          if (res.code !== 200) {
            ElMessage.error(res.message)
            return;
          }
          ElMessage.success(res.message)
          await getTeamListPages()
          await store.dispatch('email/getTeamList', {isUpdate: true})
          teamLoading.value = false;
          dialogVisible.value = false
          inputTeamName.value = ''
        } else {
          ElMessage.error(i18n.global.t('20002'))
        }
      } else {
        dialogVisibleTips.value = true;
      }
    }
    // 改变团队名称
    const activeTeams = ref(null);
    const changeTeamNameHandler = async (val) => {
      dialogVisibleChangeTeam.value = true
      activeTeams.value = val;
      inputTeamName.value = val.teamName
    }

    const changeTeamName = async () => {
      const res = await V2TeamEdit({
        id: activeTeams.value.teamId,
        name: inputTeamName.value
      })
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return
      }
      ElMessage.success(res.message)
      dialogVisibleChangeTeam.value = false;
      inputTeamName.value = ''
      await getTeamListPages()
      await store.dispatch('email/getTeamList')
    }
    // 邀请成员
    const activeTeamsInvite = ref({teamId: ''});
    const inviteTeamMenber = (val) => {
      dialogVisibleInviteMember.value = true
      activeTeamsInvite.value = val;
      inputSendID.value = ''
      // console.log(activeTeamsInvite.value.teamId, 'ff')
    }


    const activeName = ref('1')
    const handleClickClose = (element) => {
      // element.isShow = !element.isShow
      teamListPage.value.forEach(item => {
        item.isShow = (item.teamId === element.teamId) ? !item.isShow : false;
      })
    }

    return {
      handleClickTab,
      handleClickClose,
      activeName,
      handleClick,
      handleCurrentChange,
      activeTeamsInvite,
      loadingDone,
      closeDia,
      currentTeam,
      sizeTeam,
      totalTeam,
      loading,
      teamLoading,
      createConfirm,
      createTeamLink,
      inputTeamName,
      dialogVisible,
      mailWorkPosition,
      dialogVisibleTips,
      changeTeamNameHandler,
      dialogVisibleChangeTeam,
      changeTeamName,
      dialogVisibleInviteMember,
      inputSendID, inviteTeamMenber,
      userInfo,
      drag,
      teamList,
      mainKey,
      teamListPage,
      close,
      isSuperAdmin,
      isAdmin,
    };
  },
});
</script>

<style lang="less" scoped>
@import "ElCalender/less/MyTeam.less";
@import "../../less/page.less";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.my_forms {
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > div {
    line-height: 30px;
  }
}

#sendRequire {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
}

:deep(.el-button) {
  font-size: 14px !important;
}

.tab_box {
  padding: 0px 20px 20px 20px;
}

.fs14c000 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.number {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px !important;
  border: none !important;
}

.pointer {
  cursor: pointer;
}
</style>
